// Node Module Imports
import React from 'react'

import { StaticImage } from 'gatsby-plugin-image'

const UmaLogoRectangle = () => (
  <StaticImage
    src="../../assets/images/logos/rectangle-logo.png"
    className="logo"
    alt="Ultimate Medical Academy logo"
    width={175}
    quality="100"
    layout="fixed"
    placeholder="none"
    loading="eager" />
)

export default UmaLogoRectangle
